import { FC } from 'react';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import useDealThesisData from './useDealThesisData';

interface DealThesisEmptyHistoricDataColumnsProps {
  isHistoricEventsSection: boolean;
  isSectionHeader?: boolean;
  isPrimaryCell?: boolean;
  isStartSeparator?: boolean;
  isEndSeparator?: boolean;
  isHeaderTertiary?: boolean;
  isHeaderAlternate?: boolean;
  isPrimaryCellHeader?: boolean;
}

const DealThesisEmptyHistoricDataColumns: FC<DealThesisEmptyHistoricDataColumnsProps> = ({
  isHistoricEventsSection,
  isSectionHeader = false,
  isPrimaryCell = false,
  isStartSeparator = false,
  isEndSeparator = false,
  isHeaderTertiary = false,
  isHeaderAlternate = false,
  isPrimaryCellHeader = false,
}) => {
  const { caseId } = useParams();
  const {
    showHistoricDataColumns,
    emptyColumnsBeforeHistoricDataForecastYearsResults,
    emptyColumnsBeforeProgramableHistoricEventYears,
  } = useDealThesisData(caseId);

  const renderEmptyColumns = () => {
    const columns = [];
    if (showHistoricDataColumns) {
      if (isHistoricEventsSection) {
        columns.push(
          ...Array.from({ length: emptyColumnsBeforeProgramableHistoricEventYears }).map(
            (_, index) =>
              isSectionHeader ? (
                <th
                  key={`empty-${index}`}
                  className={classNames({
                    'table-primary__cell--section-start-separator': isStartSeparator,
                    'table-primary__cell--header-tertiary ': isHeaderTertiary,
                    'table-primary__cell--header-alternate': isHeaderAlternate,
                    'table-primary__cell--header': isPrimaryCellHeader,
                  })}
                />
              ) : (
                <td
                  key={`empty-${index}`}
                  className={classNames({
                    'table-primary__cell--section-start-separator': isStartSeparator,
                    'table-primary__cell--section-end-separator': isEndSeparator,
                    'table-primary__cell--primary': isPrimaryCell,
                  })}
                />
              )
          )
        );
      } else {
        columns.push(
          ...Array.from({ length: emptyColumnsBeforeHistoricDataForecastYearsResults }).map(
            (_, index) =>
              isSectionHeader ? (
                <th
                  key={`empty-${index}`}
                  className={classNames({
                    'table-primary__cell--section-start-separator': isStartSeparator,
                    'table-primary__cell--header-tertiary ': isHeaderTertiary,
                    'table-primary__cell--header-alternate': isHeaderAlternate,
                    'table-primary__cell--header': isPrimaryCellHeader,
                  })}
                />
              ) : (
                <td
                  key={`empty-${index}`}
                  className={classNames({
                    'table-primary__cell--section-start-separator': isStartSeparator,
                    'table-primary__cell--section-end-separator': isEndSeparator,
                    'table-primary__cell--primary': isPrimaryCell,
                  })}
                />
              )
          )
        );
      }
    }
    return columns;
  };

  return <>{renderEmptyColumns()}</>;
};

export default DealThesisEmptyHistoricDataColumns;
